import React, { useMemo } from 'react';
import { RadioOption } from 'components/RadioGroupField/RadioGroupField.component';
import { WorkflowConfiguration } from 'models/WorkflowConfiguration';
import { doesValueExist } from 'utils';
import { Listing } from 'models/Listing';
import TransWithNda from 'components/TransWithNda';

type UseSpecificRulesProps = Partial<
  Pick<
    WorkflowConfiguration,
    'automaticallySendNDA' | 'automaticallySendNDAEnabled'
  >
> &
  Pick<Listing, 'envelopeTemplateName'>;

const useSpecificRules = (config: UseSpecificRulesProps) => {
  const {
    automaticallySendNDA,
    automaticallySendNDAEnabled,
    envelopeTemplateName,
  } = config;

  return useMemo<RadioOption<string>[]>(
    () => [
      ...(doesValueExist(automaticallySendNDA)
        ? [
            {
              value: 'automaticallySendNDA',
              enabled: automaticallySendNDAEnabled,
              label: (
                <TransWithNda
                  i18nKey="automaticallySendNDA"
                  envelopeTemplateName={envelopeTemplateName}
                />
              ),
            },
          ]
        : []),
    ],
    [automaticallySendNDA, automaticallySendNDAEnabled, envelopeTemplateName],
  );
};

export default useSpecificRules;
